exports.onClientEntry = () => {
  // execute first on each page
}
